import type { LayoutConfig } from '@/utils/dealCalculations'
import { lockedRocketGalaxyLayout } from '@/utils/planLayoutDefaults'

/** Posições dos blocos fixos que o Proposal Studio grava na proposta. */
const SAVED_SLIDE_POSITION_KEYS = [
  'leftBlockWidth',
  'dividerX',
  'titleY',
  'projectTypeY',
  'descriptionY',
  'supportHoursY',
  'bonusY',
  'priceY',
  'paymentY',
  'loyaltyY',
  'negotiationY',
  'planTitleY',
  'serviceBlockX',
  'serviceBlockGap',
  'serviceBlockStartY',
] as const satisfies readonly (keyof LayoutConfig)[]

/**
 * Posições salvas na proposta ficam por cima do padrão do catálogo.
 * Galaxy continua no template travado.
 */
export function pickSavedSlidePositions(
  saved: Partial<LayoutConfig> | undefined,
  planLabel: string,
): Partial<LayoutConfig> {
  if (!saved || lockedRocketGalaxyLayout(planLabel)) return {}

  const patch: Partial<LayoutConfig> = {}
  for (const key of SAVED_SLIDE_POSITION_KEYS) {
    const value = saved[key]
    if (typeof value === 'number' && Number.isFinite(value)) {
      patch[key] = value
    }
  }
  if (typeof patch.leftBlockWidth === 'number' && patch.dividerX === undefined) {
    patch.dividerX = patch.leftBlockWidth
  }
  return patch
}
